import { badgeHistoryEntityName } from '../../../../backend/features/badges/shared';
import { mapBadgeHistoryFilter } from '../../../../ui/features/badge-management/utils/mapBadgeHistoryFilter';
import { useDataTableUsingState } from '@juvare/common-data-table-ui/DataTable';
import { getAccountsManageFilter } from '@juvare/contact-management/backend/features/permissions/shared';
import { useUserState } from '@juvare/contact-management/ui/hooks';
import { useStorageList } from '@juvare/platform-sdk-react/ui/hooks';
export function useBadgeHistoryTable({ badgeId, accountBadgeId }) {
    const userState = useUserState();
    const params = {
        useDataProvider: ({ filterData, sortColumnKey, sortColumnDesc, offset, limit }) => {
            const accountFilter = getAccountsManageFilter(userState);
            const initialFilter = [
                {
                    column: 'badgeId',
                    op: '=',
                    value: badgeId,
                },
                {
                    op: 'or',
                    filter: [
                        {
                            column: 'accountBadgeIds',
                            op: '=',
                            value: [],
                        },
                        {
                            column: 'accountBadgeIds',
                            op: 'overlap',
                            subFilter: {
                                entity: 'accountBadge',
                                filter: [
                                    {
                                        column: 'accountId',
                                        op: 'in',
                                        subFilter: {
                                            entity: 'account',
                                            filter: accountFilter,
                                        },
                                    },
                                ],
                            },
                        },
                    ],
                },
            ];
            if (accountBadgeId) {
                initialFilter.push({
                    op: 'or',
                    filter: [
                        { column: 'accountBadgeIds', op: 'contains', value: [accountBadgeId] },
                        {
                            column: 'accountBadgeIds',
                            op: 'overlap',
                            subFilter: {
                                entity: 'accountBadge',
                                column: 'previousAccountBadgeIds',
                                filter: [
                                    { id: accountBadgeId, op: '=' },
                                    { column: 'previousAccountBadgeIds', op: 'is-not-null' },
                                ],
                            },
                        },
                    ],
                });
            }
            const filter = mapBadgeHistoryFilter({ filterData, initialFilter });
            const response = useStorageList(badgeHistoryEntityName, {
                limit,
                offset,
                filter,
                orderBy: [{ column: sortColumnKey, desc: sortColumnDesc }],
            });
            return Object.assign(Object.assign({}, response), { data: response.data ? { rows: response.data.rows, filteredRowCount: response.data.total } : undefined, reload: () => {
                    void response.mutate();
                } });
        },
        defaultSortColumnKey: 'createdAt',
        defaultSortColumnDesc: true,
    };
    const { dataTableProps, filtersBarProps, reload } = useDataTableUsingState(params);
    return {
        filtersBarProps,
        dataTableProps,
        reload,
    };
}
